
// Servicios.js
import React from 'react';
import { motion } from 'framer-motion';
//imagenes
import cardBajaMediaTensionImg from '../assets/card_img/card_MediaTension.png';

import CardText from './CardText';

const Services = () => {
  const servicesData = [
    
     
    { title: 'Automatización Inteligente', description: 'Implementamos soluciones avanzadas de automatización para optimizar procesos industriales.',
      coverImage: cardBajaMediaTensionImg, content: (
        <>
          <h5 className="text-lg ">Detalles Técnicos</h5>
          <p>Los proyectos de media tensión incluyen:</p>
          <ul className="text-left list-disc pl-5">
            <li>Estudios preliminares.</li>
            <li>Gestión y diseño de proyectos eléctricos.</li>
            <li>Optimización de sistemas de distribución.</li>
            <li>Cálculos eléctricos y mecánicos.</li>
            <li>Diseño de líneas de distribución.</li>
            <li>Elaboración de cómputos métricos.</li>
          </ul>
          <h5 className="text-lg ">Aplicaciones  (borrar)</h5>
          <p>Se aplican en redes de distribución, parques industriales y grandes instalaciones energéticas.</p>
        </>
      ),
     },
    { title: 'Robótica Industrial', description: 'Implementación de robots colaborativos (cobots) y robots industriales para automatizar tareas peligrosas o repetitivas, mejorando la eficiencia y la seguridad.' },
    { title: 'Integración de Inteligencia Artificial', description: 'Uso de IA para mejorar la toma de decisiones y prever problemas antes de que ocurran.' },
    { title: 'Integración IoT', description: 'Conectamos dispositivos industriales mediante IoT para una mejor gestión y monitoreo.' },
    { title: 'Monitoreo en Tiempo Real', description: 'Supervisión en tiempo real de la producción, recursos y eficiencia energética a través de interfaces intuitivas.' },
    { title: 'Consultoría Especializada', description: 'Disponibilidad de soporte especializado para el análisis, diseño e implementación de sistemas industriales.' },


  ];

  return (
    <motion.section
      id="servicesIndustria"
      className="py-10"
      style={{ backgroundColor: 'var(--background-color-typeA)' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="container mx-auto px-4 text-center px-[10%]">
        <h3 className="text-3xl mb-12">Automatización Industrial 4.0 </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 col-auto">
          {servicesData.map((feature, index) => (
            <div key={index} className="flex flex-col">
              <CardText
                title={feature.title}
                description={feature.description}
                link={feature.link}
                content={feature.content}
                coverImage={feature.coverImage}


              ></CardText>

            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Services;